import axios from 'axios';

const createLicenseType = async (payload) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/license-types`, payload);

  return data;
}

const updateLicenseType = async ({ licenseTypeId, updateData }) => {
  const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/license-types/${licenseTypeId}`, updateData);

  return data;
}

const deleteLicenseType = async (licenseTypeId) => {
  await axios.delete(`${process.env.REACT_APP_API_URL}/license-types/${licenseTypeId}`);
}

const licenseTypeService = {
  createLicenseType,
  updateLicenseType,
  deleteLicenseType
};

export default licenseTypeService;
